import React from 'react'

import { cva, type VariantProps } from 'class-variance-authority'

import { Icons } from '@/components/atoms/Icons/Icons.tsx'
import { cn } from '@/lib/utils.ts'

const mobileStateVariants = cva('h-fit w-6', {
  variants: {
    state: {
      default: 'fill-black',
      ok: 'fill-green-500',
      notConnected: 'fill-orange-500',
      noMobile: 'fill-black',
      mobileRequest: 'fill-blue-600',
    },
  },
  defaultVariants: {
    state: 'default',
  },
})

export interface MobileStateProps
  extends React.HtmlHTMLAttributes<HTMLDivElement>, VariantProps<typeof mobileStateVariants> {}

export const MobileState = React.forwardRef<HTMLDivElement, MobileStateProps>(({ className, state, ...props }, ref) => {
  const Icon =
    state === 'noMobile'
      ? Icons.noMobile
      : state === 'notConnected'
        ? Icons.mobileNotConnected
        : state === 'mobileRequest'
          ? Icons.mobileRequest
          : Icons.mobileOk

  return <Icon className={cn(mobileStateVariants({ state, className }))} ref={ref} {...props} />
})
